import * as React from "react";
import type { SVGProps } from "react";
const SvgAssethistoryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="assethistory_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M746.667 640a42.667 42.667 0 1 0-85.334 0v64a42.667 42.667 0 0 0 18.987 35.499l64 42.666a42.667 42.667 0 0 0 47.36-70.997l-45.013-29.995V640z"
    />
    <path
      fill="currentColor"
      d="M448 704a256 256 0 1 1 512 0 256 256 0 0 1-512 0zm256-170.667a170.667 170.667 0 1 0 0 341.334 170.667 170.667 0 0 0 0-341.334z"
    />
    <path
      fill="currentColor"
      d="M810.667 384A42.667 42.667 0 1 0 896 384V213.333a128 128 0 0 0-128-128H256a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h170.667a42.667 42.667 0 1 0 0-85.334H256a42.667 42.667 0 0 1-42.667-42.666V213.333A42.667 42.667 0 0 1 256 170.667h512a42.667 42.667 0 0 1 42.667 42.666V384z"
    />
    <path
      fill="currentColor"
      d="M298.667 469.333a42.667 42.667 0 0 1 42.666-42.666h128a42.667 42.667 0 1 1 0 85.333h-128a42.667 42.667 0 0 1-42.666-42.667zm0-170.666A42.667 42.667 0 0 1 341.333 256h256a42.667 42.667 0 1 1 0 85.333h-256a42.667 42.667 0 0 1-42.666-42.666z"
    />
  </svg>
);
export default SvgAssethistoryIcon;
